import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Step from "@frog/source/models/Step.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

export default {
    "affiliation": "good",
    "inventory": {
        "items": [
            {"name": "Axe"},
            {"name": "Gun"},
            {"name": "Sword"},
            {"name": "Daggers"},
            {"name": "Spear"},
            {"name": "Bow"},
            {"name": "Fire Orb"},
        ],
    },
    "party": {
        "units": {
            "firekeeper": {
                "key": "firekeeper",
                "jobName": "The Firekeeper",
                "name": "Mara",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,

                "jobKey": "shaman",
                "maxhealth": 40,
                "defense": 3,

                "secondaryItem": {
                    "name": "Daggers",
                    "attackrange": 2,
                    "power": 20,
                    "element": "fire",
                    "attacktype": "steel",
                    "skillKeys": ["inflict-damage"],
                    "weaponImageKey": "daggers",
                },

                "skills": [
                    "swap",
                ],

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "THE FIREKEEPER HAS TAKEN A FATAL HIT",
                        "FIREKEEPER: ...",
                    ],
                    "slowdeath": [
                        "FIREKEEPER: The hearthlands are real.",
                        "FIREKEEPER: I will not reach them with you.",
                        "FIREKEEPER: But know they are real, and they are warm.",
                    ]
                },
            },
            "swordlord": {
                "key": "swordlord",
                "name": "Ashe",
                "jobName": "The Swordlord",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,

                "jobKey": "sword",
                "maxhealth": 50,

                "skills": [
                    "rally"
                ],

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "THE SWORDLORD HAS TAKEN A FATAL HIT.",
                        "SWORDLORD: Think nothing of it~ I will not fall this die!! Charge!!!",
                    ],
                    "slowdeath": [
                        "SWORDLORD: Please forgive me.",
                    ]
                },
                "imageSize": "contained",
                "sprites": {
                    "idle": require("@frog/source/assets/images/ember-tactics/sprites/ashe/animation.js").default,
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/ember-tactics/portraits/portraits-ember-ashe-happy.png"),
                },
            },
            // "rogue": {
            //     "key": "rogue",
            //     "jobName": "The Rogue",
            //     "name": "Ylfa",
            //     "affiliation": "good",
            //     "isRecruited": true,
            //     "hasSlowDeath": true,
            //
            //     "jobKey": "dagger",
            //     "maxhealth": 40,
            //
            //     "skills": [
            //         "pull",
            //     ],
            //     "dialogue": {
            //         "death": [
            //             PlotSteps.PlayStinger("Unit:Death:Knell"),
            //             "THE ROGUE HAS TAKEN A FATAL HIT",
            //             "ROGUE: As expected.",
            //         ],
            //         "slowdeath": [
            //             "ROGUE: These things happen. Do not let it unnerve you.",
            //         ]
            //     },
            // },
            "huntsman": {
                "jobKey": "bow",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,

                "name": "Gwyn",
                "jobName": "The Huntsman",
                "imageSize": "contained",
                "sprites": {
                    "idle": require("@frog/source/assets/images/ember-tactics/sprites/gwyn/animation.js").default,
                },

                "skills": [
                    "pull",
                ],
            },
            "onionknight": {
                "key": "onionknight",
                "jobName": "The Onionknight",
                "name": "Ambrosi",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,

                "jobKey": "hammerknight",
                "maxhealth": 60,

                "skills": [
                    "pivot",
                ],

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "THE ONION KNIGHT HAS TAKEN A FATAL HIT",
                        "ONIONKNIGHT: Bahaha!! A fine blow. Now let me show you mine.",
                    ],
                    "slowdeath": [
                        "ONIONKNIGHT: I am Ambrosi, Son of Neptar, Weilder of the Hearthaxe, and Knight of the Realm.",
                        "ONIONKNIGHT: Let the weapon that felled me be remembered as the AMBROSI-SLAYER.",
                    ]
                },
            },
        }
    },
}
